<template>
    <div v-if="buckets.length > 0" class="card mb-4 border-0 shadow-sm">
        <div class="card-header p-1 pl-3">
            {{ translate('frontend.search.filters.' + filterName) }}
        </div>

        <div class="card-block py-3 px-1">
            <div v-for="(filterData, index) in buckets" class="card-text mb-1 pl-1" :key="index"> 
                <div class="pl-4">
                    <search-filter-link :referrer-url="referrerUrl"
                                        :filter-field-name="filterName"
                                        :filter-data="filterData"
                                        :is-checked="isAppliedFilter(filterData)"
                                        :translate-values="translateValues">
                    </search-filter-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            buckets: { type: Array, required: true },
            filterName: { type: String, required: true },
            selectedFilters: { type: Array, required: true },
            referrerUrl: { type: String, required: true },
            translateValues: { type: Boolean, required: false, default: false }
        },

        methods: {
            isAppliedFilter(filterData) {
                for (let index = 0; index < this.selectedFilters.length; index++) {
                    // retain matching and empty (i.e. [not specified]) filter selections
                    if (this.selectedFilters[index] == null || filterData['key'] == this.selectedFilters[index]) {
                        return true;
                    }
                }
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        min-width: 300px;
        background-color: lighten($color: #eee, $amount: 4) !important;

        &.shadow {
            box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2) !important
        }

        .card-header {
            background-color: #eee;
            font-weight: 700;
            border: 0; 
        }
    }
</style>